import { Box, Flex, Text } from "@chakra-ui/react";
import { ReactNode } from "react";

import { RanaHeading } from "../components/rana-heading";

import { SignpostImage } from "./signpost-image";

interface SystemStatusLayoutProps {
  heading: string;
  explanation: ReactNode;
  instructions: ReactNode;
  actions: ReactNode;
}

export function SystemStatusLayout({
  heading,
  explanation,
  instructions,
  actions,
}: SystemStatusLayoutProps) {
  return (
    <Flex
      backgroundColor="brand.light_sky"
      pt={11}
      px={6}
      borderWidth="base"
      borderColor="brand.glacier"
      rounded="base"
      minWidth="3xl"
      justifyContent="space-between"
    >
      <Flex flexDirection="column">
        <RanaHeading maxW="xl" type="h2" color="brand.deep_sea" mb={6}>
          {heading}
        </RanaHeading>
        <Text color="brand.analytic" fontWeight="bold" mb={1}>
          {explanation}
        </Text>
        <Text>{instructions}</Text>
        <Box mt={8}>{actions}</Box>
      </Flex>
      <Flex alignContent="center" mr={8}>
        <SignpostImage />
      </Flex>
    </Flex>
  );
}
